module.exports = __webpack_public_path__ + "static/resources-list-policy-and-setup-2-e060902355b9f5130318cf8091e89351.png";